import { ContentAddonType } from '@/components/layout/column/ColumnModel';

export class SdkBaseAddonModel {
  #alias: string;

  constructor(addon: ContentAddonType) {
    this.#alias = addon.alias;
  }

  get alias(): string {
    return this.#alias;
  }
}
